import React from 'react'
import styles from './LargeGrid.module.scss'

function LargeGrid({ children }) {
  return <div className={styles.grid}>{children}</div>
}

export default LargeGrid
